import { Component, createPlatform, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/app.settings';
import { SelfRegisterStudentService } from 'src/app/Services/self-register-student.service';
import { SelectInstituteComponent } from './select-institute/select-institute.component';
import { StudentSelfRegistrationPopupComponent } from './student-self-registration-popup/student-self-registration-popup.component';
import * as shajs from 'sha.js';

@Component({
  selector: 'app-student-self-register',
  templateUrl: './student-self-register.component.html',
  styleUrls: ['./student-self-register.component.scss']
})
export class StudentSelfRegisterComponent implements OnInit {

  
  registerForm: FormGroup;
  public showInfoContent: boolean = false;
  institutes: any = [
    { 'id': 1, 'organization_type': 'AICTE Approved Institute' },
    { 'id': 2, 'organization_type': 'AICTE Non-Approved Institute' }
  ];
  years:any=[];
  now_year=new Date();
  // hoi_email: any = "";
  // institute_name: any = "";
  // address: any = "";
  // instituteId: any;
  // error: any;
  // states: any = [];
  // organisations: any = [];
  departments: any = [];
  // category: any;
  // designations: any = [];
  // email: any;

  constructor(
    public dialog: MatDialog,
    public selfRegister: SelfRegisterStudentService,
    public appSettings: AppSettings,
    private toastr: ToastrService,
    public fb: FormBuilder,
    public router: Router
  ) {}

  ngOnInit() {
    this.setYears();
    this.createForm();
    this.setDataNull();
  }

  setYears(){
    var year=this.now_year.getFullYear()
    for(var i=0; i<=4;i++){
      this.years[i]=year-i;
    };
  }

  createForm(){
    this.registerForm = this.fb.group({
      name: ["", Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z. ]*$'), Validators.minLength(3)])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$')])],
      mobile: ["",[Validators.required, Validators.pattern("[56789][0-9]{9}")]],
      institute_type: ["",Validators.required],
      pid: ["", Validators.required],
      institute: ["",Validators.required],
      enrollment_no: ["", Validators.required],
      department: ["", Validators.required],
      admission_date: ["", Validators.required],
      current_year: ["", Validators.required],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$"
          ),
        ]),
      ],
      confirmPassword: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            "(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$"
          ),
        ]),
      ],
    });
  }

  
  setDataNull(){
    this.registerForm.reset();
    console.log('reset');
    
  }

  PIDSelect() {
    var type=this.registerForm.controls.institute_type.value;
    // console.log(type);
    
    const dialogRef = this.dialog.open(SelectInstituteComponent, {
      data: {type}, height: '75%'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.setInstituteValues(result['data']);
      }
    });
  }

  setInstituteValues(data){
    this.registerForm.controls.institute.setValue(data['PERMANENT_ID']+" | "+data['CURRENT_INSTITUTE_NAME']);
    this.registerForm.controls.pid.setValue(data['PERMANENT_ID']);
    this.getInstituteDepartment(data['PERMANENT_ID']);
  }

  getInstituteDepartment(data){
    this.selfRegister.getSelectedInstituteDepartment(data).subscribe(data=>this.setInstituteDepartment(data['departments']));
  }

  setInstituteDepartment(data){
    this.departments=data;
  }
  // getDetails() {
  //   this.email = this.registerForm.get("email").value;
  //   this.register.getDetails(this.email).subscribe((response) => this.setData(response));
  // }

  setData(data) {
    if (data["type"] == "Error") {
      this.toastr.error(data["message"]);
    }
    if (data["type"] == "Success") {
      this.registerForm.controls.name.setValue(data["details"]["name"]);
      this.registerForm.controls.admission_date.setValue(
        data["details"]["date_of_addmission"]
      );
      this.registerForm.controls.enrollment_no.setValue(
        data["details"]["enrollment_number"]
      );
      this.registerForm.controls.mobile.setValue(data["details"]["mobile"]);
      this.registerForm.controls.sid.setValue(data["details"]["student_id"]);
      this.registerForm.controls.department.setValue(data["details"]["course"]);
    }
  }

  onSubmit(values) {
    if (this.registerForm.valid) {
      if (values.password == values.confirmPassword) {
        let tempEmail = this.registerForm.controls.email.value;
        let lowerCaseEmail = tempEmail.toLowerCase();
        let encryptedEmail = btoa(lowerCaseEmail);
        // let encryptedEmail = btoa(this.registerForm.controls.email.value);
        let encryptedPassword = shajs('sha512').update(this.registerForm.controls.password.value + encryptedEmail).digest('hex');
        values['password'] = encryptedPassword;
        values['confirmPassword'] = shajs('sha512').update(this.registerForm.controls.confirmPassword.value + encryptedEmail).digest('hex');;
        values['email'] = encryptedEmail;
        values["role_id"] = 6;
        this.selfRegister.submitStudentRegistration(values).subscribe(
          (response) => this.handleResponse(response),
          (error) =>  this.toastr.error(error.error.errors)
        );
      } else {
        this.toastr.error("Password confirmation does not match!");
      }
    } else {
      this.toastr.error("Kindly fill all the details");
    }
  }

  handleResponse(data) {
    if (data["type"] == "Success") {
      this.toastr.success("Registered Successfully!");
      this.verifyEmailPopup();
    } else {
      this.toastr.error(data["message"]);
    }
  }

  verifyEmailPopup() {
    const dialogRef = this.dialog.open(StudentSelfRegistrationPopupComponent);
    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }

  checkNumber(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  isSpace(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode == 32) {
      return false;
    }
    return true;
  }

}
